import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { WebRoutes } from "../../../Constants";
import { removeSchool } from "../../../Reducer";

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // saveCookie(Authentication, NoAuthenticated);
    dispatch(removeSchool());
    navigate(WebRoutes.EntryPage);
  }, []);

  return null;
};

export default Logout;
